import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Router, Route, Switch } from "react-router-dom";
import { Provider } from "react-redux";
import { I18nextProvider } from "react-i18next";
import i18n from "Language/i18next";
import configureStore from "Language/configureStore";

import indexRoutes from "routes/index.jsx";

import "assets/scss/material-dashboard-pro-react.css?v=1.4.0";
import "assets/scss/backoffice.css";
const preloadedState = window.__PRELOADED_STATE__;
const store = configureStore(preloadedState);

const hist = createBrowserHistory();

ReactDOM.render(
  <I18nextProvider i18n={i18n}>
    <Provider store={store}>
      <Router history={hist}>
        <Switch>
          {indexRoutes.map((prop, key) => {
            return (
              <Route
                path={"/:lng(en|it)?" + prop.path}
                component={prop.component}
                key={key}
              />
            );
          })}
        </Switch>
      </Router>
    </Provider>
  </I18nextProvider>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js